<template>
  <div class="content">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <Row>
        <FormItem label="优惠券类型：" prop="rule" style="width: 50%">
          <Radio :value="true">节次减免券</Radio>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="减免金额：" prop="discAmt" style="width: 50%">
          <Input
            v-model="formValidate.discAmt"
            placeholder="请输入大于0的数字"
            style="width: 200px"
            :disabled="details != null"
          ></Input>
          元/节
          <p class="color-gray">
            针对贫困户学生、教师子女，给予减免一定的课程费用
          </p>
        </FormItem>
        <FormItem label="使用门槛：" prop="rule" style="width: 50%">
          <RadioGroup v-model="formValidate.group">
            <Radio label="1">不限</Radio>
            <!-- <Radio label="2"
              >订单满<InputNumber
                :min="0"
                v-model="formValidate.limitAmt"
                placeholder="请输入"
              ></InputNumber
              >元</Radio
            > -->
          </RadioGroup>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="有效日期：" prop="rule" style="width: 50%">
          <DatePicker
            type="daterange"
            placeholder="请选择开始日期 ～ 请选择结束日期"
            format="yyyy-MM-dd"
            style="width: 300px"
            :value="dateRange"
            :options="dateOptions"
            @on-change="onDateChange"
            @on-clear="onDateClear"
            :editable="false"
          ></DatePicker>
        </FormItem>
      </Row>
    </Form>
  </div>
</template>

<script>
import { Alert } from 'view-design';
export default {
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  data() {
    const validateRule = (rule, value, callback) => {
      callback();
    };
    const validateDiscAmt = (rule, value, callback) => {
      let length = 0;
      const arr = value.split('.');
      let reg = /^[0-9]{1,20}$/;
      if (arr.length === 2) {
        length = arr[1].length;
      }

      if (value === '') {
        callback(new Error('请输入减免金额'));
      } else if (Number.parseFloat(value) <= 0) {
        callback(new Error('请输入大于0的金额'));
      } else if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
      } else if (arr.length > 2) {
        callback(new Error('请输入一个小数点'));
      } else if (isNaN(value)) {
        callback(new Error('只能输入数字'));
      } else {
        callback();
      }
    };
    return {
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      dateRange: '',
      formValidate: {
        discountType: 1,
        discAmt: null,
        limitAmt: null,
        beginTime: '',
        endTime: '',
        group: '1'
      },
      ruleValidate: {
        rule: [
          { required: true, validator: validateRule, trigger: 'blur' }
        ],
        discAmt: [{ required: true, validator: validateDiscAmt, trigger: 'blur' }],
      }
    }
  },
  watch: {
    details(newVal) {
      this.fillForm(newVal)
    }
  },
  methods: {
    // 编辑回填
    fillForm(info) {
      let { discountType, limitAmt, discAmt, beginTime, endTime } = info
      this.formValidate.discountType = discountType
      this.formValidate.group = limitAmt == 0 ? '1' : '2'
      this.formValidate.limitAmt = limitAmt == 0 ? 0 : Number(limitAmt) / 100
      this.formValidate.discAmt = String(Number(discAmt) / 100)
      this.formValidate.beginTime = beginTime
      this.formValidate.endTime = endTime
      this.dateRange = [beginTime, endTime]
    },
    checkDiscAmt() {
      let discAmt = String(this.formValidate.discAmt)
      if (discAmt === '') {
        this.$Message.warning('请输入减免金额');
        return false
      }
      let length = 0;

      const arr = discAmt.split('.');
      let reg = /^[0-9]{1,20}$/;
      if (arr.length === 2) {
        length = arr[1].length;
      }

      if (Number.parseFloat(discAmt) <= 0) {
        this.$Message.warning('减免金额请输入大于0的金额');
        return false
      } else if (length > 2) {
        this.$Message.warning('减免金额最多只能输入两位小数的金额');
        return false
      } else if (arr.length > 2) {
        this.$Message.warning('减免金额只能输入一个小数点');
        return false
      } else if (isNaN(discAmt)) {
        this.$Message.warning('减免金额只能输入数字');
        return false
      }
      return true
    },
    checkForm() {
      let { discountType, discAmt, limitAmt, beginTime, endTime, group } = this.formValidate
      if (!discountType) {
        this.$Message.warning('请选择优惠券类型');
        return false
      }
      if (group == 2 && !limitAmt) {
        this.$Message.warning('请输入使用门槛金额');
        return false
      }
      if (!this.checkDiscAmt()) {
        //  this.$Message.warning('请输入减免金额');
        return false
      }
      console.log(beginTime, 'beginTime')
      if (!beginTime) {
        this.$Message.warning('请选择有效日期');
        return false
      }

      return true
    },
    onDateChange(date) {

      this.formValidate.beginTime = date[0] ? `${date[0]} 00:00:00` : ''
      this.formValidate.endTime = date[1] ? `${date[1]} 23:59:59` : ''
    },
    onDateClear() {
      this.formValidate.beginTime = ''
      this.formValidate.endTime = ''
    },
    // 获取参数
    async getParameter() {
      return new Promise(async (resolve, reject) => {
        let { discountType, discAmt, limitAmt, beginTime, endTime, group } = this.formValidate
        resolve({
          discountType, discAmt: Number(discAmt) * 100, limitAmt: group == 1 ? 0 : limitAmt * 100, beginTime, endTime,
        })
      }


      )
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 16px;
}
</style>